import hidden from './entries/hidden.js';
import client from './entries/client.js';
import nav from './entries/nav.js';
import wix from './entries/wix.js';
import scripts from './entries/scripts.js';
import images from './entries/images.js';
import fonts from './entries/fonts.js';
import fcp from './entries/fcp.js';
import tti_tbt from './entries/tti-tbt.js';
import lcp from './entries/lcp.js';
import cls from './entries/cls.js';
import fid from './entries/fid.js';

import config from './utils/config.js';
import markAndMeasure from './actions/markAndMeasure.js';
import log from './actions/log.js';
import sendBI from './actions/bi.js';

const measurements = [];
measure(window);

export default function main() {
    return measurements;
}

function measure(window) {
    if (typeof Promise !== 'function') {
        return;
    }

    const {document, performance, PerformanceObserver} = window;
    const script = document.currentScript || document.getElementById('wix-perf-measure');
    if (script) {
        config.load(script.dataset);
    }

    const visibility = hidden(window);
    const interaction = fid(window, performance, PerformanceObserver);

    measurements.push(client(window));
    measurements.push(nav(window, performance, PerformanceObserver));
    measurements.push(wix(window));

    const ss = scripts(window, performance, PerformanceObserver);
    measurements.push(ss);

    const is = images(window, performance, PerformanceObserver);
    measurements.push(is);

    const fs = fonts(window, performance, PerformanceObserver);
    measurements.push(fs);

    const paints = fcp(window, performance, PerformanceObserver);
    measurements.push(paints);

    const interactive = tti_tbt(window, performance, PerformanceObserver, paints, interaction);
    measurements.push(interactive);

    const lastPaint = lcp(window, performance, PerformanceObserver, paints, interactive);
    measurements.push(lastPaint);

    measurements.push(cls(window, performance, PerformanceObserver, interactive, lastPaint));

    if (config.log) {
        log(visibility, interaction, measurements);
    }
    markAndMeasure(performance, [ss, is, fs, interaction], [paints, interactive, lastPaint]);

    measurements.push(visibility);
    measurements.push(interaction);

    Object.freeze(measurements);

    if (config.bi) {
        sendBI(window, measurements);
    }

    window.performanceMeasurements = measurements;
    const event = new window.CustomEvent('performanceMeasurements', {
        detail: measurements
    });
    window.dispatchEvent(event);
}
